/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-props-no-spreading */
import styled, { css } from "styled-components";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { renderTextWithLineBreaks } from '../../Constants/utils'
import { X } from "../../Constants/assets";

// Stylings
// small pop up styling
const InnerContainer = styled.div`
  ${(props) =>
    props.modalTitle == "modals.welcome.info_title" &&
    css`
      width: 520px;
      height: max-content;
      padding: 30px 10px;
    `}
  ${(props) =>
    props.modalTitle != "modals.welcome.info_title" &&
    css`
      width: 600px;
      height: 320px;
    `}
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  text-align: center;
  font-family: "Roboto", sans-serif;
  z-index: 103;
  position: fixed;
  animation: zoomIn 0.2s ease-in-out;
`;
const TextContainer = styled.div`
  ${(props) =>
    props.modalTitle == "modals.welcome.info_title" &&
    css`
      height: max-content;
    `}
  ${(props) =>
    props.modalTitle != "modals.welcome.info_title" &&
    css`
      height: 58%;
    `}
    button {
    background: none;
    border: none;
    cursor: pointer;
    text-decoration: underline;
  }
`;
const Br = styled.div`
  ${(props) =>
    props.modalTitle != "modals.welcome.info_title" &&
    css`
      height: 15%;
    `}
`;
const HeaderText = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 50%;
  color: ${(props) => props.theme.colors.black};
  ${(props) =>
    props.modalTitle == "modals.welcome.info_title" &&
    css`
      height: max-content;
      margin-bottom:15px
    `}
  ${(props) =>
    props.modalTitle != "modals.welcome.info_title" &&
    css`
      height: 25%;
    `}
`;
const ParagraphText = styled.div`
  font-size: 16px;
  line-height: 135%;
  color: ${(props) => props.theme.colors.black};
  display: inline-table;
  ${(props) =>
    props.modalTitle == "modals.welcome.info_title" &&
    css`
      width: 439px;
      height: max-content;
      margin-bottom:20px;
    `}
  ${(props) =>
    props.modalTitle != "modals.welcome.info_title" &&
    css`
      width: 85%;
    `}
    button {
    background: none;
    border: none;
    cursor: pointer;
    text-decoration: underline;
  }
`;
const ButtonContainer = styled.button`
  width: 40%;
  height: 50px;
  background: ${(props) => props.theme.colors.darkGreen};
  border-radius: 8px;
  cursor: pointer;
  border: none;
`;
const SeeInfoButtonContainer = styled.button`
  width: 40%;
  height: 50px;
  background: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.darkGreen};
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
`;
const ButtonContainerLine = styled.div`
  width: 100%;
  height: max-content;
  display: flex;
  justify-content: space-evenly;
`;
const GetStartedButton = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 2.05vh;
  color: ${(props) => props.theme.colors.white};
  width: 100%;
`;
const ShowInfoButton = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 2.05vh;
  color: ${(props) => props.theme.colors.darkGreen};
  width: 100%;
`;
// large popup styling
const InfoInnerContainer = styled.div`
  width: 70%;
  min-height: 540px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  text-align: center;
  font-family: "Roboto", sans-serif;
  z-index: 100;
  height: fit-content;
`;
const BodyContainer = styled.div`
  width: 94%;
  height: 90%;
  margin: 0 auto;
  justify-content: center;
`;

const HeaderContainer = styled.div`
    display: flex;
    margin 35px auto;
    justify-content: space-between;
    ${css`
        @media (max-height: 730px) {
            /* CSS styles for screens with a height less than 730px */
            margin-bottom: 0;
        }
    `}
`;
const Title = styled.div`
  font-weight: bold;
  font-size: 24px;
`;
const XContainer = styled.div``;
const ParagraphContainer = styled.div`
  width: 50%;
  text-align: -webkit-left;
  line-height: 20px;
  font-size: 16px;
  margin-bottom: 40px;
  @media (max-width: 1400px) {
    font-size: 14px;
  }
`;
const VideoContainer = styled.div`
  width: 50%;
`;

const TutorialDiv = styled.div`
  padding: 56.25% 0 0 0;
  ${"" /* position: relative; */}
`;

export default function Modal({
  modalTitle,
  modalText,
  modalButton,
  modalInfoButton,
  // playerStatus,
  // eslint-disable-next-line prettier/prettier
  toggleShow = () => { },
  toggleGameDefinitions,
  toggleModal,
  playerStatus,
  show,
  player,
  styling = {},
  additionalBudgetValid,
  additionalBudget,
  commentAdditionalBudget,
  setAdditionalBudgetPopUp,
  startTurn,
  isPaused,
  projectName,
  projectObjective,
  toggleBeginTurnPopUp,
  isStartTurnMessageShowing,
  togglePlanYourProjectPopUp,
  setNewTurn,
  endGameFunction,
  isPlanning,
  projectId
}) {
  const [ModalStage, setModalStage] = useState(0);
  const { t } = useTranslation();
  const [disable, setDisable] = useState(false);
  const handleEndGameClick = (event) => {
    isPlanning(false)
    endGameFunction(true, 0, 0, "game has been ended by user");
    setDisable(true);
  };

  const insertVariablesToTranslation = (translationText) => {
    let modifiedText = translationText; // Create a new variable to hold the modified text

    if (modifiedText.includes("$B") && typeof player.budget !== 'undefined') {
      modifiedText = modifiedText.replace("$B", `$${Math.abs(player.budget)}`);
    }
    if (modifiedText.includes("$V") && typeof player.earnedValue !== 'undefined') {
      modifiedText = modifiedText.replace("$V", Math.abs(player.earnedValue));
    }
    if (modifiedText.includes("$R") && typeof player.resources.regular !== 'undefined') {
      modifiedText = modifiedText.replace("$R", Math.abs(player.resources.regular));
    }
    if (modifiedText.includes("$S") && typeof player.resources.executive !== 'undefined') {
      modifiedText = modifiedText.replace("$S", Math.abs(player.resources.executive));
    }
    if (modifiedText.includes("$E") && typeof player.resources.expensive !== 'undefined') {
      modifiedText = modifiedText.replace("$E", Math.abs(player.resources.expensive));
    }
    if (modifiedText.includes("$P") && typeof player.position !== 'undefined') {
      modifiedText = modifiedText.replace("$P", Math.abs(player.position));
    }
    if (modifiedText.includes("$N")) {
      modifiedText = modifiedText.replace("$N", t(`global_variables.projects.${projectId}.project_name`, { projectId }));
    }
    if (modifiedText.includes("$O")) {
      modifiedText = modifiedText.replace("$O", t(`global_variables.projects.${projectId}.project_objective`, { projectId }));
    }
    console.log(modifiedText);
    return modifiedText;
  }


  if (show) {
    if (ModalStage == 0) {
      return (
        <InnerContainer
          modalTitle={modalTitle}
          modalText={modalText}
        >
          <Br modalTitle={modalTitle} />
          <TextContainer modalTitle={modalTitle}>
            <HeaderText modalTitle={modalTitle}> {t(modalTitle)} </HeaderText>
            <ParagraphText modalTitle={modalTitle} projectName={projectName}>
              {" "}
              {insertVariablesToTranslation(t(modalText))}{" "}
              {modalTitle === "modals.welcome.info_title" && (
                <button type="button" onClick={() => toggleGameDefinitions()}>
                  {t('modals.welcome.link')}{" "}
                </button>
              )}{" "}
            </ParagraphText>
          </TextContainer>
          <ButtonContainerLine>
            {modalTitle === "modals.welcome.info_title" && (
              <SeeInfoButtonContainer
                onClick={() => {
                  setModalStage(1);
                  toggleModal(true);
                }}
              >
                {Array.isArray(modalInfoButton) ? (
                  modalInfoButton.map((current) => {
                    return (
                      <ShowInfoButton
                        key={current.key}
                        onClick={current.onClick}
                      >
                        {current.text}
                      </ShowInfoButton>
                    );
                  })
                ) : (
                  <ShowInfoButton> {t(modalInfoButton)} </ShowInfoButton>
                )}
              </SeeInfoButtonContainer>
            )}
            {modalTitle === "modals.additional_budget.info_title" && (
              <SeeInfoButtonContainer
                onClick={() => {
                  toggleShow();
                  additionalBudget();
                }}
              >
                <ShowInfoButton> {t("modals.additional_budget.button2")} </ShowInfoButton>
              </SeeInfoButtonContainer>
            )}
            {modalTitle === "modals.end_of_turn.info_title" && (
              <>
                <SeeInfoButtonContainer
                  onClick={() =>
                    isStartTurnMessageShowing
                      ? startTurn(false) && toggleShow()
                      : toggleShow() && toggleBeginTurnPopUp(true)
                  }
                >
                  <ShowInfoButton> {t(modalInfoButton)} </ShowInfoButton>
                </SeeInfoButtonContainer>
                <ButtonContainer
                  onClick={() => {
                    toggleShow();
                    isPaused(true);
                    isPlanning(true);
                    setNewTurn(true);
                  }}
                >
                  <GetStartedButton> {t(modalButton)} </GetStartedButton>
                </ButtonContainer>
              </>
            )}
            {modalTitle === "modals.end_game.info_title" && (
              <>
                <SeeInfoButtonContainer onClick={() => toggleShow()}>
                  <ShowInfoButton> {t(modalInfoButton)} </ShowInfoButton>
                </SeeInfoButtonContainer>
                <ButtonContainer
                  disabled={disable}
                  onClick={handleEndGameClick}
                >
                  <GetStartedButton disabled={disable}>
                    {" "}
                    {t(modalButton)}{" "}
                  </GetStartedButton>
                </ButtonContainer>
              </>
            )}
            {additionalBudgetValid && (
              <>
                <ButtonContainer
                  onClick={() => {
                    toggleShow();
                    setAdditionalBudgetPopUp(false);
                  }}
                >
                  <GetStartedButton> {t(modalButton)} </GetStartedButton>
                </ButtonContainer>
              </>
            )}
            {(modalTitle == "modals.game_over.info_title" ||
              modalTitle == "modals.project_completed.info_title") && (
                <>
                  <ButtonContainer
                    onClick={() => {
                      toggleShow();
                      endGameFunction(
                        true,
                        0,
                        0,
                        "player finished all his tasks"
                      );
                    }}
                  >
                    <GetStartedButton> {t(modalButton)} </GetStartedButton>
                  </ButtonContainer>
                </>
              )}
            {!additionalBudgetValid &&
              modalTitle !== "modals.end_of_turn.info_title" &&
              modalTitle !== "modals.game_over.info_title" &&
              modalTitle !== "modals.project_completed.info_title" &&
              modalTitle != "modals.end_game.info_title" &&
              modalTitle !== "modals.welcome.info_title" && (
                <ButtonContainer
                  onClick={() => {
                    toggleShow();
                  }}
                >
                  <GetStartedButton> {t(modalButton)} </GetStartedButton>
                </ButtonContainer>
              )}
            {!additionalBudgetValid &&
              modalTitle !== "modals.end_of_turn.info_title" &&
              modalTitle !== "modals.game_over.info_title" &&
              modalTitle !== "modals.project_completed.info_title" &&
              modalTitle != "modals.end_game.info_title" &&
              modalTitle === "modals.welcome.info_title" && (
                <ButtonContainer
                  onClick={() => {
                    toggleShow();
                    togglePlanYourProjectPopUp(true);
                  }}
                >
                  <GetStartedButton> {t(modalButton)} </GetStartedButton>
                </ButtonContainer>
              )}
          </ButtonContainerLine>
        </InnerContainer>
      );
    }

    return (
      <InfoInnerContainer>
        <BodyContainer>
          <HeaderContainer>
            <Title>{t('modals.tutorial.info_title')}</Title>
            <XContainer
              onClick={() => {
                toggleShow();
                togglePlanYourProjectPopUp(true);
                setModalStage(0);
              }}
            >
              <X style={{ cursor: "pointer" }} />
            </XContainer>
          </HeaderContainer>
          <div style={{ display: "flex" }}>
            <ParagraphContainer>
              {renderTextWithLineBreaks(t('modals.tutorial.info_text'))}
              {/* {t('modals.tutorial.info_text').replace(/\n/g, <br/>)} */}
              <br />
              <b>{t('modals.tutorial.bold_part')}</b>
            </ParagraphContainer>
            <VideoContainer>
              <iframe
                src="https://player.vimeo.com/video/671696142?h=0bdc37885e&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameBorder="0"
                width="88%"
                height="256px"
                allow="autoplay; fullscreen; picture-in-picture"
                // allowfullscreenstyle="position:absolute;top:0;left:0;width:100%;height:100%;" // keep allowfullscreenstyle lower case
                title="Tutorial"
              />
              <script src="https://player.vimeo.com/api/player.js" />
            </VideoContainer>
          </div>
        </BodyContainer>
      </InfoInnerContainer>
    );
  }
  return null;
}
